import { SelectOptionType } from '@octano/global-ui';
import { AccountIdentificationFlat } from '../../../../types/account';
import { PaginationRequestType } from '../../../../types/paginationRequestType';

export interface StudentsRemovalRequestStudent {
  studyPlanEnrollment: {
    id: number;
    studentId: number;
    status: string;
    statusName: string;
  };
  studyPlanVersion: { id: number; name: string };
  student: AccountIdentificationFlat;
  removalRequest?: {
    requestedBy: AccountIdentificationFlat;
    requestedAt: Date;
    state: string;
  };
}

export type StudentsRemovalRequestStudentsResponse =
  PaginationRequestType<StudentsRemovalRequestStudent>;

export interface StudentsRemovalRequestCreateFormResponse {
  types: { id: string; name: string }[];
  studyPlanEnrollment: {
    id: number;
    studentId: number;
    status: string;
    statusName: string;
  };
  studyPlanVersion: { id: number; name: string };
  student: AccountIdentificationFlat;
  removalRequest?: {
    requestedBy: AccountIdentificationFlat;
    requestedAt: Date;
  };
}

export type StudentsRemovalRequestFormFile = {
  id: number;
  name: string;
};

export interface StudentsRemovalRequestCreateFormFields {
  type: SelectOptionType | null;
  comment: string;
  files: StudentsRemovalRequestFormFile[];
}

export interface StudentsRemovalRequestCreateRequest {
  typeId: number;
  comment?: string;
  filesIds?: number[];
}

export type StudentsRemovalRequestDetailResponse = {
  student: {
    accountId: number;
    accountNames: string;
    accountLastNames: string;
    identificationValueFormatted: string;
  };
  studyPlan: string;
  removalRequest: {
    comment: string;
    type: string;
    status: string;
  };
  files: {
    id: number;
    name: string;
    extension: string;
    type: string;
  }[];
};

export enum StudentsRemovalRequestState {
  Pending = 'pending',
  Rejected = 'rejected',
  Approved = 'approved',
}